module.exports = __webpack_public_path__ + "static/media/7-2-python-logo-free-download-png.85333030.png";